import {getUrlPattern} from '../utils';
import {AppSharedKeys} from './sharedKeys';
import {SharedValueKey} from '@epic-core/hooks';
import {cmsApi} from './cms.api';
import {RouteMatchOrUrlParse} from '../types/route.types';

let context;

interface Context {
    [key: string]: any;
}

export const getSharedContext = (): Context => {
    return context;
};

export const setSharedContext = (newContext: Context): void => {
    context = newContext;
};

export interface InitSharedValueResponse {
    key: SharedValueKey<string>;
    value: any;
}

export const fetchCmsPageSharedValues = async (
    match: RouteMatchOrUrlParse,
    cmsUrlPattern?: string
): Promise<InitSharedValueResponse[]> => {
    const urlPattern = getUrlPattern(match, cmsUrlPattern);
    const responses = await Promise.all([await cmsApi.getPageData(urlPattern)]);
    responses.forEach((response) => {
        delete response.pageSlugParam;
        delete response.cmsPageMap;
    });

    return [
        {
            key: AppSharedKeys.CmsStore,
            value: {
                [urlPattern]: responses[0] || {}
            }
        }
    ];
};

export const getInitialCmsPageSharedValues = (cmsUrlPattern?: string) => {
    return async (match: RouteMatchOrUrlParse): Promise<InitSharedValueResponse[]> => {
        return await fetchCmsPageSharedValues(match, cmsUrlPattern);
    };
};
